<div class="session-expired-overlay" *ngIf="visible">
    <div class="session-expired-modal">
      <h2 class="modal-title">Sesión cerrada</h2>
      <p class="modal-message">
        Tu sesión ha expirado por inactividad. Por favor, vuelve 
        a iniciar sesión para continuar con tu assessment.
      </p>
      <div class="modal-button-container">
        <button class="iniciar-sesion-btn" (click)="iniciarSesion()">Iniciar sesión</button>
      </div>
    </div>
  </div>